var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2002 4C4.09563 4 3.2002 4.89543 3.2002 6V18C3.2002 19.1046 4.09563 20 5.2002 20H13.2002C14.3048 20 15.2002 19.1046 15.2002 18V9.41421C15.2002 9.01639 15.0422 8.63486 14.7609 8.35355L10.8466 4.43934C10.5653 4.15804 10.1838 4 9.78598 4H5.2002ZM4.2002 6C4.2002 5.44772 4.64791 5 5.2002 5H9.2002V8.5C9.2002 9.32843 9.87177 10 10.7002 10H14.2002V18C14.2002 18.5523 13.7525 19 13.2002 19H5.2002C4.64791 19 4.2002 18.5523 4.2002 18V6ZM13.9931 9H10.7002C10.4241 9 10.2002 8.77614 10.2002 8.5V5.20711L13.9931 9Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.8773b3192ddc05e441dd2e443168d3e6.svg";
export { ForwardRef as ReactComponent };